export function setPageTitle(title: string): void {
    if (title) {
        document.title = `${title} — SumMeet`;
    } else {
        document.title = "SumMeet";
    }
}

export const joinBaseUri = (baseUri: string, path: string): string => {
    const newBase = baseUri.endsWith("/") ? baseUri.substring(0, baseUri.length-1) : baseUri;
    const newPath = path.startsWith("/") ? path.substring(1) : path;
    return `${newBase}/${newPath}`;
}

export const ToastFastInterval = 2000;